import actions from './actions'
import getters from './getters'

import {createStore} from 'vuex'

const store = createStore({
    state() {
        return {
            laravelAuthToken: null,
            contests: null,
            is_loading: false,
            addonForm: null,
            userForm: null,
            userFormData: {
                admin_level: '',
            },
            simpleUserForm: null,
            entryForm: {
                image: {
                    value: '',
                },
                main_image: {
                    full: '',
                    large: '',
                    thumb: '',
                },
                item_name: '',
                meta: {
                    location: '',
                    student_age: '',
                    student_grade: '',
                },
                item_att2: '',
                item_att1: '',
                is_student: false,
                item_description: '',
                item_att3: '',
                photo_permission: 0,
            },
            entry: {},
            page: null,
            singleEntry: null,
            contest: null,
            contestApis: null,
            user: null,
            entriesData: {
                data: [],
            },
            entries: [],
            loading: false,
            submitting: false,
            showLoginPopup: false,
            project: '',
            query: {},
            cookies: {},
            categoryDropdown: false,
            placesDropdown: false,
            selectedSingleCategories: {},
            selectSingleCategories: {},
            activeType: null,
            itemsPerPage: 20,
            items: {},
            users: {},
            directory: {},
            sponsoredDirectory: {},
            searchOptions: {
                directoryQuery: '',
                visibleDirectoryQuery: '',
                facetsForAlgolia: [],
                latlng: null,
                lat: null,
                lng: null,
                mainFacet: 'hcategory.lvl0'
            },
            listing: null,
            lists: {
                top: [],
                new: [],
                show: [],
                ask: [],
                job: [],
            },
            modal: {
                title: ''
            },
        }
    },

    actions,
    mutations: {
        setState (state, { key, data }) {
            state[key] = data;
        },
        setObjectState(state, { obj, key, data }) {
            state[obj][key] = data;
        },
        setSubObjectState(state, { obj, subObj, key, data }) {
            state[obj][subObj][key] = data;
        },
        HANDLE_VOTE(state, {vote, entry}) {
            // const newState = JSON.parse(JSON.stringify(state));
            if (state.entriesData) {
                const index = state.entriesData.data.findIndex(x => x.id === entry.id)
                state.entriesData.data[index].VotesCount = vote;
            } else {
                state.singleEntry.VotesCount = vote;
            }
        },

        SET_SIMPLE_USER_FORM(state, {simpleUserForm}) {
            state.simpleUserForm = simpleUserForm;
        },
        SET_USER(state, user) {
            //#####console.log('SET_USER', user);
            state.user = user
        },
        LOGIN(state, user) {
            state.user = user
        },
        TOGGLE_LOGIN_POPUP(state) {
            state.showLoginPopup = !state.showLoginPopup;
        },
        SET_CONTEST_APIS: (state, {contestApis}) => {
            //#####console.log('SET_CONTEST_APIS', contestApis);
            state.contestApis = contestApis;
        },

        SET_CONTESTS: (state, {contests}) => {
            //#####console.log('SET_CONTESTS', contests);
            state.contests = contests;
        },

        SET_ENTRIES_DATA: (state, {entriesData}) => {
            //#####console.log('SET_ENTRIES_DATA', entriesData);
            state.entriesData = entriesData;
        },
        SET_SINGLE_ENTRY: (state, singleEntry) => {
            //#####console.log('SET_SINGLE_ENTRY', singleEntry);
            state.singleEntry = singleEntry;
        },
        SET_ENTRY_FORM: (state, {entryForm}) => {
            //#####console.log('SET_ENTRY_FORM', entryForm, state.user);
            state.entryForm = entryForm;
        },
        SET_ENTRY: (state, {entry}) => {
            //#####console.log('SET_ENTRY', entry);
            state.entry = entry;
        },
        SET_ADDON_FORM: (state, {addonForm}) => {
            //#####console.log('SET_ADDON_FORM', addonForm);
            state.addonForm = addonForm;
        },
        SET_USER_FORM: (state, {userForm}) => {
            //#####console.log('SET_USER_FORM', userForm);
            state.userForm = userForm;
        },
        SET_PAGE: (state, {page}) => {
            //#####console.log('SET_PAGE', page);
            state.page = page;
        },
        SET_CONTEST: (state, {contest}) => {
            //#####console.log('SET_CONTEST', contest);
            // If we are changing contests,
            // do some data cleanup (reset entryForm)
            if (state.contest && (state.contest.id !== contest.id)) {
                state.entryForm = null;
            }
            state.contest = contest;
        },
        CATEGORY_DROPDOWN: (state, display) => {
            //#####console.log('cat dropdown', display);
            state.placesDropdown = display;
        },
        PLACES_DROPDOWN: (state, display) => {
            state.categoryDropdown = display;
        },
        SET_ACTIVE_TYPE: (state, { type }) => {
            state.activeType = type
        },

        SET_LIST: (state, { type, ids }) => {
            state.lists[type] = ids
        },

        SET_STATE(state, {key, data}) {
            state[key] = data;
        },
        LOADING(state, loading) {
            state.loading = loading;
        }
    },
    getters,
})
export default store;